/**
 * Docs from
 * https://primeng.org/popover
 */
export const popover = {
  root: {
    gutter: 0,
  },
  content: {
    padding: '0',
  },
  css: ({ dt }: { dt: any }) => `
    .p-popover:before, .p-popover:after {
      display: none;
    }
  `,
};
